import React, { useState, useEffect } from 'react'
import { UsersListPagination } from '../../../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import { EditAgentModel } from './EditAgentModel'
import plusIcon from '../../../../../_metronic/images/smlplus.svg'
import {
  GET_SALES_AGENT,
  DELETE_USER_AGENT,
  UPDATE_USER_STATUS,
  GET_AGENT_LEADER_LIST_FOR_AGENT,
} from '../../../../../utils/GraphQLAPI'
import { useLazyQuery, useMutation } from '@apollo/client'
import { Spinner } from 'react-bootstrap'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import Dropdown from 'react-bootstrap/Dropdown'
import { CreateAgentModel } from './CreateAgentModel'
import SwalThinkingImage from '../../../../../_metronic/images/swal_thinking_face.svg'

import uuid from 'react-uuid'
import { useNavigate, useParams } from 'react-router'
import { GLOBAL_CONSTANTS } from '../../../../../utils/GlobalConstants'

import { formatCreateAgentInput } from '../SalesChannelHelpers'
import { DownloadTemplate } from '../../../../sharedComponent/DownloadTemplate/DownloadTemplate'
const MySwal = withReactContent(Swal)

interface Props {
  salesData: any
  agentLeaders: any
}

const AgentInfo = ({ salesData, agentLeaders }: Props) => {
  const [page, updatePage] = useState<any>(0)
  const [agentsData, setAgentsData] = useState<any>([])
  const [listOptions, setListOptions] = useState<any>({
    page: 1,
    perPage: 10,
    salesChannelId: localStorage.getItem('salesEditId'),
  })
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [showEditAppModal, setShowEditAppModal] = useState<boolean>(false)
  const [editDatas, setEditDatas] = useState('')

  const [agentId, setAgentId] = useState('')
  const [activate, setActivate] = useState<any>({ userId: '', isDisabled: '' })
  const navigate = useNavigate()
  const getUrlParams = useParams()

  const updateRowsPerPage = (value: any) => {
    setListOptions((prevOptions: any) => {
      return { ...prevOptions, perPage: value, page: page + 1 }
    })
  }

  useEffect(() => {
    setListOptions((prevOptions: any) => {
      return { ...prevOptions, page: page + 1 }
    })
  }, [page])

  const openEditModal = (event: any, editValue: any, id: any) => {
    setShowEditAppModal(true)
    setShowCreateAppModal(false)

    setEditDatas(editValue)

    setAgentId(id)
    getAgentLeaderList({
      variables: {
        salesChannelId: localStorage.getItem('salesEditId'),
      },
    })
  }
  const openAddModal = (event: any, editValue: any) => {
    setShowCreateAppModal(true)
    setShowEditAppModal(false)
    getAgentLeaderList({
      variables: {
        salesChannelId: localStorage.getItem('salesEditId'),
      },
    })
  }

  const handleAddCloseModal = () => {
    setEditDatas('')

    setShowCreateAppModal(false)
  }

  const handleEditCloseModal = () => {
    setEditDatas('')

    setShowEditAppModal(false)
  }

  // List API
  const [getSalesChannelAgents, { loading, refetch }] = useLazyQuery(GET_SALES_AGENT, {
    fetchPolicy: 'network-only',
    variables: {
      getSalesChannelAgentsInput: listOptions,
    },
    onCompleted: (data) => {
      setAgentsData(data.getSalesChannelAgents)
      refetch()
    },
    onError: (err) => console.log('error', err),
  })

  useEffect(() => {
    getSalesChannelAgents()
  }, [refetch])

  useEffect(() => {
    getSalesChannelAgents()
  }, [listOptions])

  const [deleteAgent] = useMutation(DELETE_USER_AGENT, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Agent deleted successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      refetch()
    },
    onError: (error) => {
      MySwal.fire({
        icon: 'error',
        title: error.message,
      })
    },
  })

  const confirmationDelete = (e: any, agentEmail: any) => {
    MySwal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this",
      iconHtml: `<img src=${SwalThinkingImage}>`,
      customClass: {
        icon: 'no-border',
      },
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it',
      confirmButtonColor: '#3E97FF',
      cancelButtonText: 'No, cancel !',
      cancelButtonColor: 'rgb(39 37 37 / 52%)',
      reverseButtons: true,
    }).then(function (result) {
      if (result.value) {
        deleteAgent({ variables: { emailId: agentEmail } })
      }
    })
  }

  // Activate / Inactivate
  const confirmTitle = 'Are you sure?'
  const cancelText = 'No, cancel !'
  const cancelBtnClr = 'rgb(39 37 37 / 52%)'
  const agentActivate = (e: any, id: any, activeValue: any) => {
    e.preventDefault()
    setActivate((prevOptions: any) => {
      return { ...prevOptions, userId: id, isDisabled: activeValue }
    })

    if (activeValue) {
      MySwal.fire({
        title: confirmTitle,
        iconHtml: `<img src=${SwalThinkingImage}>`,
        customClass: {
          icon: 'no-border',
        },
        showCancelButton: true,
        confirmButtonText: 'Yes, Inactivate',
        confirmButtonColor: '#3E97FF',
        cancelButtonText: cancelText,
        cancelButtonColor: cancelBtnClr,
        reverseButtons: true,
      }).then(agentAction)
    } else {
      MySwal.fire({
        title: confirmTitle,
        iconHtml: `<img src=${SwalThinkingImage}>`,
        customClass: {
          icon: 'no-border',
        },
        showCancelButton: true,
        confirmButtonText: 'Yes, Activate',
        confirmButtonColor: '#3E97FF',
        cancelButtonText: cancelText,
        cancelButtonColor: cancelBtnClr,
        reverseButtons: true,
      }).then(agentAction)
    }
  }

  const [updateAgentStatus] = useMutation(UPDATE_USER_STATUS, {
    variables: {
      userId: activate.userId,
      isDisabled: activate.isDisabled,
    },
    onCompleted: (data) => {
      refetch()
    },
  })
  const agentAction = (result: any) => {
    if (result.value) {
      updateAgentStatus()
      MySwal.fire({
        title: 'Success!',
        text: 'Agent status updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      })
    }
  }
  //agentLeaderList
  const [agentLeaderList, setAgentLeaderList] = useState<any>([])
  const [getAgentLeaderList] = useLazyQuery(GET_AGENT_LEADER_LIST_FOR_AGENT, {
    onCompleted: (res) => {
      setAgentLeaderList(
        res.getAgentLeaderListForAgent.map((agentLeader: any) => ({
          ...agentLeader,
          leaderId: agentLeader.id,
        }))
      )
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  // Audit
  const handleOpenAuditModal = (agentId: any) => {
    navigate(`/${getUrlParams.adminUser}/saleschannelagent-audit`, {
      state: {
        itemId: agentId,
        itemType: 'Agent',
        salesId: localStorage.getItem('salesEditId'),
      },
    })
  }

  const handleCreateAgentSubmit = async (
    agentValue: any,
    createAgents: any,
    uploadAgent: any,
    trackId?: string,
    salesChannelId?: string
  ) => {
    const agentArray = await formatCreateAgentInput(agentValue, agentLeaderList)
    //call the createAgents API if agents < 10
    if (agentArray !== undefined && agentArray?.length <= 10) {
      const payload = agentArray.map((agent: any) => {
        return {
          emailId: agent?.agentEmailID,
          firstName: agent?.agentFirstName,
          lastName: agent?.agentLastName,
          leaderId: agent?.agentLeaderCode ? agent?.agentLeaderCode : null,
          repId: agent?.agentRepId,
        }
      })
      // Sync Call
      await createAgents({
        variables: {
          createAgentInputs: payload,
          salesChannelId: salesChannelId,
        },
      })
    }
    ///call the upload agents API if agents > 10
    if (agentArray !== undefined && agentArray?.length > 10) {
      await uploadAgent({
        variables: {
          isVerified: true,
          salesChannelId: salesChannelId,
          trackId: trackId,
          userData: agentArray,
        },
      })
    }
  }

  return (
    <>
      <div className='min-h-lg-400px min-h-md-300px p-4'>
        <div className='row mb-5'>
          <div className='col-6'>
            <label className='d-flex align-items-center fs-4 fw-bold mb-4 lh-1'>
              <span className='fs-2 fw-bolder text-gray-900'>Agent Lists</span>
            </label>
          </div>
          <div className='col-6 text-end'>
            <DownloadTemplate
              href={process.env.REACT_APP_AGENT_TEMPLATE_DOWNLOAD}
              text='Download Template'
            />
            <button
              className='btn btn-primary fs-6 p-3 w-142px h-43px ms-4'
              onClick={(e) => openAddModal(e, '')}
              type='button'
            >
              <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
              <span>Add Agent</span>
            </button>
            {
              <CreateAgentModel
                show={showCreateAppModal}
                handleClose={handleAddCloseModal}
                refetchList={refetch}
                salesChannelId={salesData.salesChannelId}
                agentLeaderList={agentLeaderList}
                handleCreateAgentSubmit={handleCreateAgentSubmit}
              />
            }
          </div>
        </div>
        {loading ? (
          <div className='text-center'>
            <Spinner animation='border' className='text-gray-600' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </Spinner>
          </div>
        ) : agentsData.totalCount !== 0 ? (
          <div className='table-responsive-md'>
            <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                  <th className='min-w-125px text-gray-400 fs-7 fw-semibold text-uppercase ps-0'>
                    Agent First Name
                  </th>
                  <th className='min-w-125px text-gray-400 fs-7 fw-semibold text-uppercase ps-0'>
                    Agent Last Name
                  </th>
                  <th className='min-w-125px text-gray-400 fs-7 fw-semibold text-uppercase ps-0'>
                    Agent Email ID
                  </th>
                  <th className='min-w-125px text-gray-400 fs-7 fw-semibold text-uppercase ps-0'>
                    Status
                  </th>
                  <th className='min-w-125px text-gray-400 fs-7 fw-semibold text-uppercase ps-0'>
                    Agent Rep Id
                  </th>
                </tr>
              </thead>
              <tbody>
                {agentsData?.agents &&
                  agentsData?.agents?.map((item: any, index: number) => {
                    if (item?.user) {
                      return (
                        <tr className='border-bottom-2' key={uuid()}>
                          <td className='text-gray-700 fs-6 ps-0  fw-semibold'>
                            {item?.user?.firstName}
                          </td>
                          <td className='text-gray-700 fs-6 ps-0  fw-semibold'>
                            {item?.user?.lastName}
                          </td>
                          <td className='text-gray-700 fs-6 ps-0  fw-semibold'>
                            {item?.user?.emailId}
                          </td>
                          <td
                            className={`fs-6 ps-0 fw-semibold ${item?.user?.isDisabled ? 'text-danger' : 'text-success'
                              }`}
                          >
                            {item?.user?.isDisabled ? 'Inactive' : 'Active'}
                          </td>
                          <td className='text-gray-700 fs-6 ps-0  fw-semibold'>
                            {item?.user?.repId}
                          </td>
                          <td>
                            <Dropdown className='show-override'>
                              <Dropdown.Toggle
                                id='dropdown-custom-1'
                                className='text-gray-600 btn btn-sm btn-icon btn-active-light-primary btn-light-primary btn-arrow-overide'
                                style={{ background: 'none !important' }}
                              >
                                <i className='bi bi-three-dots-vertical fs-7 text-primary'></i>
                              </Dropdown.Toggle>
                              <Dropdown.Menu className=' py-2 menu-state-bg-primary'>
                                <Dropdown.ItemText
                                  as='div'
                                  className='text-gray-600 fs-7 menu-item'
                                >
                                  <div
                                    className='menu-link'
                                    onClick={(e) =>
                                      openEditModal(e, JSON.stringify(item.user), item.id)
                                    }
                                  >
                                    Edit
                                  </div>
                                </Dropdown.ItemText>

                                <Dropdown.ItemText
                                  as='div'
                                  className='text-gray-600 fs-7 menu-item'
                                >
                                  <div
                                    className='menu-link'
                                    onClick={(e) => {
                                      item?.user?.isDisabled
                                        ? agentActivate(e, item?.userId, false)
                                        : agentActivate(e, item?.userId, true)
                                    }}
                                  >
                                    {' '}
                                    {item?.user?.isDisabled ? 'Activate' : 'Inactivate'}
                                  </div>
                                </Dropdown.ItemText>
                                <Dropdown.ItemText
                                  as='div'
                                  className='text-gray-600 fs-7 menu-item'
                                >
                                  <div
                                    className='menu-link'
                                    onClick={(e) => handleOpenAuditModal(item.id)}
                                  >
                                    Audit
                                  </div>
                                </Dropdown.ItemText>
                                <Dropdown.ItemText
                                  as='div'
                                  className='text-gray-600 fs-7 menu-item'
                                >
                                  <div
                                    className='menu-link text-danger'
                                    onClick={(e) => confirmationDelete(e, item?.user?.emailId)}
                                  >
                                    Delete
                                  </div>
                                </Dropdown.ItemText>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      )
                    }
                  })}
                {showEditAppModal && (
                  <EditAgentModel
                    show={showEditAppModal}
                    handleClose={handleEditCloseModal}
                    editData={editDatas}
                    refetchList={refetch}
                    salesData={salesData}
                    agentId={agentId}
                    agentLeaderList={agentLeaderList}
                  />
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div className='fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center'>
            <div>No Results Found</div>
          </div>
        )}
      </div>
      {agentsData?.totalCount > 0 ? (
        <div className='card-footer border-0'>
          <UsersListPagination
            page={page}
            total={agentsData.totalCount}
            updatePage={updatePage}
            recordsPerPage={(e: any) => {
              updateRowsPerPage(parseInt(e))
            }}
            rowsPerPage={listOptions.perPage}
          />
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default AgentInfo
